import { DashboardCard } from './DashboardCard';
import { CardGrid } from './CardGrid';
import { PredictionDashboardFilter } from '../dataProvider';

const icon = {
  revenue: 'heroicons-outline:currency-dollar',
  profit: 'flowbite:chart-mixed-dollar-solid',
  user: 'uil:user',
  deposit: 'flowbite:arrow-down-to-bracket-solid',
  withdraw: 'mdi:bank-transfer-out',
} as const;

const unitKey = {
  currency: 'module.dashBoard.unitCurrency',
  user: 'module.dashBoard.unitUsers',
} as const;

type StandardListCardsProps = {
  filter: PredictionDashboardFilter;
  tradingType: NonNullable<PredictionDashboardFilter['tradingType']>;
  depositType: string;
  withdrawType: string;
};

export const StandardListCards = ({
  filter,
  tradingType,
  depositType,
  withdrawType,
}: StandardListCardsProps) => (
  <>
    <CardGrid>
      <DashboardCard
        resource="dashboard/new-registered-users"
        filter={filter}
        title="module.dashBoard.newUsers"
        tooltip="module.dashBoard.newUsersTooltip"
        icon={icon.user}
        unitKey={unitKey.user}
        color="error"
        getValues={(data) => [Number(data?.users ?? 0)]}
      />
      <DashboardCard
        resource="dashboard/transfer-stats"
        filter={{ ...filter, type: depositType }}
        title="module.dashBoard.deposit"
        tooltip="module.dashBoard.depositTooltip"
        icon={icon.deposit}
        unitKey={unitKey.currency}
        color="success"
        getValues={(data) => [Number(data?.amount ?? 0)]}
      />
      <DashboardCard
        resource="dashboard/revenue"
        filter={{ ...filter, type: tradingType }}
        title="module.dashBoard.revenue"
        tooltip="module.dashBoard.revenueTooltip"
        icon={icon.revenue}
        unitKey={unitKey.currency}
        color="warning"
        getValues={(data) => [Number(data?.revenue ?? 0)]}
      />
    </CardGrid>
    <CardGrid withTopPadding>
      <DashboardCard
        resource="dashboard/trading-stats"
        filter={{ ...filter, type: tradingType }}
        title="module.dashBoard.activeTraders"
        tooltip="module.dashBoard.activeTradersTooltip"
        icon={icon.user}
        unitKey={unitKey.user}
        color="info"
        getValues={(data) => [Number(data?.trades ?? 0)]}
      />
      <DashboardCard
        resource="dashboard/transfer-stats"
        filter={{ ...filter, type: withdrawType }}
        title="module.dashBoard.withdraw"
        tooltip="module.dashBoard.withdrawTooltip"
        icon={icon.withdraw}
        unitKey={unitKey.currency}
        color="error"
        getValues={(data) => [Number(data?.amount ?? 0)]}
      />
      <DashboardCard
        resource="dashboard/trading-stats"
        filter={{ ...filter, type: tradingType }}
        title="module.dashBoard.tradingStats"
        tooltip="module.dashBoard.tradingStatsTooltip"
        icon={icon.profit}
        unitKey={unitKey.currency}
        color="info"
        getValues={(data) => [Number(data?.volume ?? 0)]}
      />
    </CardGrid>
  </>
);
